var ICON_SIZE = {
  TINY: '20px',
  SMALL: '28px',
  MEDIUM: '32px',
  LARGE: '44px'
};
var ICON_DIRECTION = {
  UP: 0,
  RIGHT: 90,
  DOWN: 180,
  LEFT: 270
};
var ICON_BORDER_RADIUS_DIRECTION = {
  ALL: '10px',
  UP: '10px 10px 0 0',
  RIGHT: '0 10px 10px 0',
  DOWN: '0 0 10px 10px',
  LEFT: '10px 0 0 10px',
  CIRCLE: '50%'
};

export { ICON_BORDER_RADIUS_DIRECTION, ICON_DIRECTION, ICON_SIZE };
